import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from "@angular/common/http";
import {baseUrl} from "../../../../../../core/constants/base-url";
import {downloadFileHeaders} from "../../../../../../core/models/http-headers";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DownloadPackagesExcelApiService {
  private http = inject(HttpClient);

  public downloadPackagesExcel(): Observable<HttpEvent<Blob>> {
    return this.http.get(`${baseUrl}/product-packages/download`, {
      headers: downloadFileHeaders,
      responseType: 'blob',
      reportProgress: true,
      observe: 'events'
    });
  }
}
